import { createApiClient } from './axios';

export default createApiClient();
